import { useEffect, useState } from 'react';

import { useAuth } from '@/components/auth/auth-provider';

interface BookmarkData {
  articleSlug: string;
  notes?: string;
  tags?: string[];
}

export function useBookmark(articleSlug: string) {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  // Check if article is bookmarked on mount
  useEffect(() => {
    const checkBookmarkStatus = async () => {
      try {
        const response = await fetch('/api/reading/bookmarks');
        if (response.ok) {
          const data = await response.json();
          const bookmark = data.data?.find(
            (b: { article_slug: string }) => b.article_slug === articleSlug
          );
          setIsBookmarked(!!bookmark);
        }
      } catch (error) {
        console.error('Error checking bookmark status:', error);
      }
    };

    if (user) {
      checkBookmarkStatus();
    } else {
      setIsBookmarked(false);
    }
  }, [articleSlug, user]);

  const toggleBookmark = async (notes?: string, tags?: string[]) => {
    setIsLoading(true);
    try {
      const response = await fetch('/api/reading/bookmarks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          articleSlug,
          notes,
          tags
        })
      });

      if (response.ok) {
        const data = await response.json();
        setIsBookmarked(data.bookmarked);
        return data.bookmarked;
      }
    } catch (error) {
      console.error('Error toggling bookmark:', error);
    } finally {
      setIsLoading(false);
    }
    return false;
  };

  return {
    isBookmarked,
    isLoading,
    toggleBookmark
  };
}
